import { render, staticRenderFns } from "./aitype.vue?vue&type=template&id=acb9167e&scoped=true"
import script from "./aitype.vue?vue&type=script&lang=js"
export * from "./aitype.vue?vue&type=script&lang=js"
import style0 from "./aitype.vue?vue&type=style&index=0&id=acb9167e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb9167e",
  null
  
)

export default component.exports